__turbopack_context__.v({
  "address": "_2-sNLG_address",
  "dark": "_2-sNLG_dark",
  "details": "_2-sNLG_details",
  "emailLink": "_2-sNLG_emailLink",
  "lessSpace": "_2-sNLG_lessSpace",
  "placeholder": "_2-sNLG_placeholder",
  "profile": "_2-sNLG_profile",
  "profileName": "_2-sNLG_profileName",
  "profileTitle": "_2-sNLG_profileTitle",
  "root": "_2-sNLG_root",
});
